import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Image, Box } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import cardsIcon from './assets/cards.svg'
import videoIcon from './assets/video.svg'
import audioIcon from './assets/audio.svg'
import readingIcon from './assets/reading.svg'
import conceptIcon from './assets/concept.svg'
import writingIcon from './assets/writing.svg'

const ACTIVITY_INFO = {
  cards: {
    label: t('Flashcards'),
    icon: cardsIcon,
  },
  video: {
    label: t('Video'),
    icon: videoIcon,
  },
  audio: {
    label: t('Audio'),
    icon: audioIcon,
  },
  reading: {
    label: t('Reading'),
    icon: readingIcon,
  },
  writing: {
    label: t('Writing'),
    icon: writingIcon,
  },
  concept: {
    label: t('Concept'),
    icon: conceptIcon,
  },
}

const ActivityLabel = ({ type }) => {
  const info = ACTIVITY_INFO[type]

  if (!info) {
    return null
  }

  return (
    <Flex alignItems="center">
      <Image mr="1x" src={info.icon} width={24} alt={info.label} />
      <Box variant="text.tinyTitle">{info.label}</Box>
    </Flex>
  )
}

ActivityLabel.propTypes = {
  type: PropTypes.oneOf([
    'video',
    'audio',
    'reading',
    'writing',
    'concept',
    'cards',
  ]),
}

export default ActivityLabel
